export default __webpack_public_path__ + "assets/webgl/picking-25.95bb169a.glb";